import React, { Component } from 'react';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import DropdownLanguage from './DropdownLanguage';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            redirectToLogin: false,
            successMsg: null,
            error: null,
            token: new URLSearchParams(window.location.search).get('token'),
            newPassword: '',
            newPasswordConfirm: '',
            isFormValid: false,
            passwordError: null,
            matchError: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handlePasswordConfirmChange = this.handlePasswordConfirmChange.bind(this);
    }

    validatePassword(password) {
        const hasNumbers = /\d/.test(password);
        const hasLowerAndUpper = /(?=.*[a-z])(?=.*[A-Z])/.test(password);
        const hasSpecialChars = /[@#$]/.test(password);
        const hasAtLeast8Chars = password.length >= 8 && password.length <= 255;
        const doesNotHaveWhiteSpaces = !/\s/.test(password);

        const errors = [];
        if (!hasNumbers) errors.push(this.props.t('changePassword.validation.hasNumbers'));
        if (!hasLowerAndUpper) errors.push(this.props.t('changePassword.validation.hasLowerAndUpper'));
        if (!hasSpecialChars) errors.push(this.props.t('changePassword.validation.hasSpecialChars'));
        if (!hasAtLeast8Chars) errors.push(this.props.t('changePassword.validation.hasAtLeast8Chars'));
        if (!doesNotHaveWhiteSpaces) errors.push(this.props.t('changePassword.validation.doesNotHaveWhiteSpaces'));

        return {
            isValid: errors.length === 0,
            errors: errors
        };
    }

    handlePasswordChange(e) {
        const { value } = e.target;
        const validation = this.validatePassword(value);

        this.setState({
            newPassword: value,
            passwordError: validation.isValid ? null : validation.errors.join('\n')
        }, () => {
            this.validateForm();
        });
    }

    handlePasswordConfirmChange(e) {
        const { value } = e.target;
        const { newPassword } = this.state;

        this.setState({
            newPasswordConfirm: value,
            matchError: value !== newPassword ? this.props.t('changePassword.passwordsDoNotMatch') : null
        }, () => {
            this.validateForm();
        });
    }

    validateForm() {
        const { newPassword, newPasswordConfirm, passwordError, matchError } = this.state;
        const passwordValidation = this.validatePassword(newPassword);

        this.setState({
            isFormValid: passwordValidation.isValid &&
                newPassword === newPasswordConfirm &&
                newPassword !== '' &&
                newPasswordConfirm !== ''
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        const { newPassword, newPasswordConfirm, token } = this.state;

        axios({
            method: 'POST',
            url: 'api/Login/ResetPassword',
            data: {
                token: token,
                newPassword: newPassword,
                confirmPassword: newPasswordConfirm
            },
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({
                    successMsg: this.props.t('changePassword.successMessage'),
                    error: null,
                    newPassword: '',
                    newPasswordConfirm: ''
                }, () => {
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 2000);
                });
            })
            .catch(error => {
                const errorMessage = error.response && error.response.data
                    ? error.response.data
                    : this.props.t('changePassword.errorMessage');

                this.setState({
                    error: errorMessage,
                    successMsg: null
                });
            });
    }

    render() {
        const { error, successMsg, isFormValid, newPassword, newPasswordConfirm, passwordError, matchError } = this.state;
        const { t } = this.props;
        return (
            <>
                <Row className="mt-2">
                    <Col sm={{ span: 4, offset: 4 }}>
                        <DropdownLanguage />
                    </Col>
                </Row>
                <Row className="mb-5 mt-5 text-center">
                    <Col sm={{ span: 4, offset: 4 }}>
                        <Image src="/img/ValidatedIdLogo.png" rounded />
                    </Col>
                </Row>
                <Row>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <h4>{t('changePassword.title')}</h4>
                        <hr />
                        {
                            successMsg !== null &&
                            <Alert variant={'success'} className="mt-2">
                                {successMsg}
                            </Alert>
                        }
                        {
                            passwordError !== null &&
                            <Alert variant={'danger'} className="mt-2">
                                {passwordError}
                            </Alert>
                        }
                        {
                            matchError !== null &&
                            <Alert variant={'danger'} className="mt-2">
                                {matchError}
                            </Alert>
                        }
                        <Form onSubmit={this.handleSubmit} >
                            <Form.Group controlId="newPassword">
                                <Form.Label>{t('changePassword.newPassword')}</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder={t('login.passwordTitle')}
                                    name="newPassword"
                                    value={newPassword}
                                    onChange={this.handlePasswordChange}
                                    required
                                />
                            </Form.Group>
                            <Form.Group controlId="newPasswordConfirm">
                                <Form.Label>{t('changePassword.repeatPassword')}</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder={t('login.passwordTitle')}
                                    name="newPasswordConfirm"
                                    value={newPasswordConfirm}
                                    onChange={this.handlePasswordConfirmChange}
                                    required
                                />
                            </Form.Group>

                            <ButtonToolbar>
                                <Button
                                    type="submit"
                                    className="green-button"
                                    disabled={!isFormValid}
                                >
                                    {t('general.saveLabel')}
                                </Button>
                                <Link to="/" className="ml-2">
                                    <Button className="grey-button">
                                        <span>{t('general.cancelLabel')}</span>
                                    </Button>
                                </Link>
                            </ButtonToolbar>
                        </Form>
                    </Col>
                </Row>
            </>
        );
    }
}

export default withTranslation()(ChangePassword);

